
















import { Vue, Component, Prop } from "vue-property-decorator";
import { VIPContact } from '@/loader';
import ContactEdit from "./ContactEdit.vue";

@Component({
	components: {
		ContactEdit,
	},
})
export default class ContactModal extends Vue {
	@Prop({ type: String, default: "contact_modal" })
	public id!: string;

	@Prop({ type: VIPContact, default: null })
	public item!: VIPContact | null;

	public show() {
		this.$bvModal.show(this.id);
	}

	public hide(event: string = null) {
		this.$bvModal.hide(this.id);
		if (event) {
			this.$emit(event, this.item);
		}
	}
}
